import { render, staticRenderFns } from "./NewMunicipalityEntity.vue?vue&type=template&id=5f2111fe&scoped=true&"
import script from "./NewMunicipalityEntity.vue?vue&type=script&lang=js&"
export * from "./NewMunicipalityEntity.vue?vue&type=script&lang=js&"
import style0 from "./NewMunicipalityEntity.vue?vue&type=style&index=0&id=5f2111fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2111fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f2111fe')) {
      api.createRecord('5f2111fe', component.options)
    } else {
      api.reload('5f2111fe', component.options)
    }
    module.hot.accept("./NewMunicipalityEntity.vue?vue&type=template&id=5f2111fe&scoped=true&", function () {
      api.rerender('5f2111fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Entities/NewMunicipalityEntity.vue"
export default component.exports